import { Components, Theme } from '@mui/material/styles';

const MuiFormControl: Components<Theme>['MuiFormControl'] = {};

export default MuiFormControl;
